import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Mail, MessageCircle, Book, ExternalLink } from 'lucide-react';
import { Card } from './ui/card';
import { Button } from './ui/button';

export const SupportPage = () => {
  const navigate = useNavigate();

  const supportOptions = [
    {
      icon: MessageCircle,
      title: 'Centro de Ayuda',
      description: 'Encuentra respuestas a preguntas frecuentes',
      action: () => alert('Próximamente: Centro de ayuda'),
    },
    {
      icon: Mail,
      title: 'Contactar Soporte',
      description: 'Envíanos un correo electrónico',
      action: () => window.open('mailto:soporte@tetrisbiblico.com'),
    },
    {
      icon: Book,
      title: 'Guía de Uso',
      description: 'Aprende a usar todas las funciones',
      action: () => alert('Próximamente: Guía de uso'),
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-background via-background to-secondary/20 pb-24">
      {/* Header */}
      <header className="sticky top-0 bg-background/80 glass border-b border-border backdrop-blur-lg z-10">
        <div className="max-w-2xl mx-auto px-4 py-4">
          <div className="flex items-center gap-4">
            <button
              onClick={() => navigate(-1)}
              className="p-2 hover:bg-secondary rounded-full interactive"
            >
              <ArrowLeft className="w-6 h-6" />
            </button>
            <div>
              <h1 className="text-2xl font-bold" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                Soporte
              </h1>
              <p className="text-sm text-muted-foreground">Estamos aquí para ayudarte</p>
            </div>
          </div>
        </div>
      </header>

      <main className="max-w-2xl mx-auto px-4 py-6">
        {/* Support Options */}
        <div className="space-y-4 mb-8">
          {supportOptions.map((option, index) => {
            const Icon = option.icon;
            return (
              <Card
                key={index}
                onClick={option.action}
                className="p-5 cursor-pointer interactive hover:shadow-lg border-l-4 border-primary"
              >
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0">
                    <Icon className="w-6 h-6 text-primary" />
                  </div>
                  <div className="flex-1">
                    <h3 className="font-semibold text-lg mb-1">{option.title}</h3>
                    <p className="text-sm text-muted-foreground">{option.description}</p>
                  </div>
                  <ExternalLink className="w-5 h-5 text-muted-foreground" />
                </div>
              </Card>
            );
          })}
        </div>

        {/* FAQ Section */}
        <Card className="p-6">
          <h2 className="text-xl font-bold mb-4">Preguntas Frecuentes</h2>
          <div className="space-y-4">
            <div>
              <h3 className="font-semibold mb-2">¿Cómo se revelan los versículos?</h3>
              <p className="text-sm text-muted-foreground">
                Los versículos se revelan al completar líneas en el juego de Tetris. Cada línea completada revela un versículo del libro que hayas seleccionado.
              </p>
            </div>
            <div>
              <h3 className="font-semibold mb-2">¿Cómo funciona la caída libre?</h3>
              <p className="text-sm text-muted-foreground">
                Mantén presionada la flecha hacia abajo por más de 500ms para activar la caída libre rápida. Suelta para detenerla.
              </p>
            </div>
            <div>
              <h3 className="font-semibold mb-2">¿Puedo ver mis versículos coleccionados?</h3>
              <p className="text-sm text-muted-foreground">
                Sí, ve a la sección "Colección" desde el menú principal para ver todos los versículos que has revelado.
              </p>
            </div>
          </div>
        </Card>
      </main>
    </div>
  );
};